import { axiosApiInstance, headers, intro_headers } from './_httpHeaders';

// U031. 상담 신청 페이지 업무 타입 코드 조회
export const getSysCodeList = (sysGroupCode) =>
  axiosApiInstance({
    method: 'get',
    headers: intro_headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/selectSysCodeList.do`,
    params: {
      sysGroupCode: sysGroupCode,
    },
  });

// U033. 공지사항 목록 조회
export const getNoticeClientList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/selectNoticeClientList.do`,
    params: {
      allTargetYn: reqParam.allTargetYn,
      checkDate: reqParam.checkDate === 0 ? null : reqParam.checkDate,
      startDt: reqParam.startDt,
      endDt: reqParam.endDt,
      searchText: reqParam.searchText,
      PageStart: reqParam.PageStart,
      PerPageNum: reqParam.PerPageNum,
    },
  });

// U034. 공지사항 목록 상세 조회
export const getNoticeClientDetailView = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/selectNoticeClientDetailView.do`,
    params: {
      noticeSeq: reqParam.noticeSeq,
      allTargetYn: reqParam.allTargetYn,
      checkDate: reqParam.checkDate === 0 ? null : reqParam.checkDate,
      startDt: reqParam.startDt,
      endDt: reqParam.endDt,
      searchText: reqParam.searchText,
    },
  });

// U035. FAQ 목록
export const getFaqClientList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/selectFaqClientList.do`,
    params: {
      CFaqType: reqParam.CFaqType,
      searchText: reqParam.searchText,
      pageStart: reqParam.pageStart,
      perPageNum: reqParam.perPageNum,
    },
  });

// U036. 자료실 목록
export const getArchiveClient = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/selectArchiveClient.do`,
    params: {
      pageStart: reqParam.pageStart,
      perPageNum: reqParam.perPageNum,
      CArchvType: reqParam.CArchvType,
      searchText: reqParam.searchText,
    },
  });

// U037. 문의 목록
export const getClientInquiryList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: {
      'content-type': 'application/json;charset=UTF-8',
      'X-API-Key': 'EDI2021TEST!',
      Authorization: sessionStorage.getItem('TOKEN'),
    },
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/selectClientInquiryList.do`,
    params: {
      pageStart: reqParam.pageStart,
      perPageNum: reqParam.perPageNum,
      checkDate: reqParam.checkDate === 0 ? null : reqParam.checkDate,
      searchText: reqParam.searchText,
      startDt: reqParam.startDt,
      endDt: reqParam.endDt,
    },
  });

// U038. 문의 상세보기
export const getClientInquiryDetailView = (inqrySeq) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/selectClientInquiryDetailView.do`,
    params: {
      inqrySeq: inqrySeq,
    },
  });

// U039. 문의 등록
export const insertQuestion = (dataParam) =>
  axiosApiInstance({
    method: 'post',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/insertQuestion.do`,
    data: {
      inqrySj: dataParam.inqrySj,
      inqryDc: dataParam.inqryDc,
      inqryNm: dataParam.inqryNm,
      inqryId: dataParam.inqryId,
    },
  });

// U040. 문의 수정
export const changeQuestion = (dataParam) =>
  axiosApiInstance({
    method: 'post',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/changeQuestion.do`,
    data: {
      inqrySeq: dataParam.inqrySeq,
      inqrySj: dataParam.inqrySj,
      inqryDc: dataParam.inqryDc,
    },
  });

// U041. 자료실 유저 다운로드
export const ArchivefileDownload = (archvSeq) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    responseType: 'blob',
    url: `${process.env.REACT_APP_API_URL}/user/common/ArchivefileDownload.do`,
    params: {
      archvSeq: archvSeq,
    },
  });

// U042. 유저 문의 삭제
export const deleteInqryTotalData = (daraParam) =>
  axiosApiInstance({
    method: 'delete',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/deleteInqry.do`,
    data: {
      dataList: daraParam,
    },
  });

// U044. 로그인후 공지사항 팝업 뷰 리스트
export const getAllNoticePopupLoginList = () =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/selectAllNoticePopupLoginList.do`,
  });

// U047. 문의 게시판 엑셀  데이터 다운로드
export const excellClientInquiryList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    responseType: 'arraybuffer',
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/excellClientInquiryList.do`,
    params: {
      checkDate: reqParam.checkDate === 0 ? null : reqParam.checkDate,
      searchText: reqParam.searchText,
      startDt: reqParam.startDt,
      endDt: reqParam.endDt,
      inqryUsCode: reqParam.inqryUsCode,
    },
  });

// U048. 공지사항  게시판 엑셀  데이터 다운로드
export const excellNoticeClientList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    responseType: 'arraybuffer',
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/excellNoticeClientList.do`,
    params: {
      usCode: reqParam.usCode,
      allTargetYn: reqParam.allTargetYn,
      checkDate: reqParam.checkDate === 0 ? null : reqParam.checkDate,
      startDt: reqParam.startDt,
      endDt: reqParam.endDt,
      searchText: reqParam.searchText,
    },
  });

// U067. 공지사항 게시판 파일 다운로드
export const noticeFileDown = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    responseType: 'blob',
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/noticeFileDown.do`,
    params: {
      fileSeq: reqParam,
    },
  });

// U1114. 대시보드 공지 [전체/MY]
export const getNoticeDashBoard = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/selectNoticeDashBoard.do`,
  });

// 자료실 드롭다운 리스트
export const getArcvCodeList = () =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/selectCodeList.do`,
    params: {},
  });

// FAQ 드롭다운 리스트
export const getFaqTypeList = () =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/selectFaqTypeList.do`,
    params: {},
  });
